import React from "react"
import { TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, FloatingActionButton, FontIcon, SelectField, MenuItem, CircularProgress } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import autobind from "class-autobind"
import Table from "../../../components/common/Table"
import TableActionBar from "../../../components/layout/TableActionBar"
import * as api from "../../../api"
import moment from "moment"
import _ from "lodash"
import AppStateStore from "../../../stores/AppStateStore"
import strings from "../../../localization/strings"
import ExternalLink from "../../common/externalLink/ExternalLink"
import { IFAMAccountDTO } from "../../../models/data/account_manager/FAMAccountDTO"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AccountManagerClientTabDrawer from "./client_tab_details/AccountManagerClientTabDrawer"
import { EPlanType, IAccountManagerClientsReportColumns, IAccountManagerSearchReportParameters } from "../../../models"
import ColumnSelector from "../../../components/common/columnSelector/ColumnSelector"
import * as reportAction from "../../../actions/ReportAction"

interface IProps {
    accountManagerId: string
}

interface IState {
    clientAccounts: IFAMAccountDTO[]
    selectedClientAccounts: IFAMAccountDTO[]
    drawerOpen: boolean
    activeClient: boolean
    searchText: string
    total: number
    offset: number
    limit: number
    selectedAccountId: string
    editDrawer: boolean
    loading: boolean
    accountType: string
    planType: string
    clientColumns: IAccountManagerClientsReportColumns
}

export default class AccountManagerDetailsClientTab extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        const clientColumns: IAccountManagerClientsReportColumns = localStorage.getItem("ClientColumns") ?
			JSON.parse(localStorage.getItem("ClientColumns")) :
			{
				IncludeName: true,
                IncludeLastSeen: true,
                IncludePEPM: true,
                IncludeSignUpDate: true,
                IncludeDateUpdated: true,
                IncludeRelationshipManager: true,
                IncludePlan: true,
			}
        this.state = {
            clientAccounts: [],
            selectedClientAccounts: [],
            drawerOpen: false,
            activeClient: true,
            searchText: "",
            total: 0,
            offset: 0,
            limit: 100,
            selectedAccountId: null,
            editDrawer: false,
            loading: false,
            accountType: "All",
            planType: "All",
            clientColumns
        }
        autobind(this)
    }

    componentDidMount(): void {
        this.getData()
    }

    getData() {
        this.setState({ loading: true }, () => {
            const IsTestAccount = this.getAcccountTypeFilterValue(this.state.accountType, strings.Test_Account)
            const IsDemoAccount = this.getAcccountTypeFilterValue(this.state.accountType, strings.Demo_Account)
            const IsClientAccount = this.getAcccountTypeFilterValue(this.state.accountType, strings.Client_Account)
            api.getAccountManagerAccounts({ AccountManagerId: this.props.accountManagerId, Active: this.state.activeClient, IsTestAccount, IsDemoAccount, IsClientAccount, Text: this.state.searchText, Page: this.state.offset / this.state.limit, Limit: this.state.limit, PlanType: this.getPlanTypeFilterValue(this.state.planType) })
                .then(res => {
                    this.setState({ clientAccounts: res.data.Accounts as IFAMAccountDTO[], total: res.data.TotalDocumentsCount, loading: false, })
                })
                .catch(err => {
                    err.response.status === 400 &&
                        AppStateStore.setProgressSnackbarContent(err.response.data.message)
                })
        })
    }

    getDataDownload() {
        const IsTestAccount = this.getAcccountTypeFilterValue(this.state.accountType, strings.Test_Account)
        const IsDemoAccount = this.getAcccountTypeFilterValue(this.state.accountType, strings.Demo_Account)
        const IsClientAccount = this.getAcccountTypeFilterValue(this.state.accountType, strings.Client_Account)
		const clientReportParams = {
			AccountManagerId: this.props.accountManagerId,
            Active: this.state.activeClient,
            IsTestAccount,
            IsDemoAccount,
            IsClientAccount,
            Text: this.state.searchText,
            Page: 0,
            Limit: this.state.total,
            PlanType: this.getPlanTypeFilterValue(this.state.planType),
            ReportColumns: this.state.clientColumns
		} as IAccountManagerSearchReportParameters
		reportAction.downloadAccountManagerClientAccountsData(clientReportParams)
	}

    onSearchChange = _.debounce(searchText => this.setState({ searchText, offset: 0 }, () => this.getData()), 1000)

    clickRow(row) {
        if (row === null) {
            this.setState({
                selectedAccountId: null,
                drawerOpen: true,
                editDrawer: false
            })
        } else {
            this.setState({
                selectedAccountId: row.AccountId,
                drawerOpen: true,
                editDrawer: true
            })
        }
    }

    getAcccountTypeFilterValue(selectedFilter: string, filter: string) {
        return selectedFilter === filter ? true : null
    }

    getPlanTypeFilterValue(selectedFilter: string) {
        return selectedFilter === "All" ? null : EPlanType[selectedFilter]
    }

    AccountsTable = () => (
        !this.state.clientAccounts.length ?
            <div>
                <h2 style={{ textAlign: "center", marginTop: 25 }}>
                    {strings.No_employee_found.replace(strings.Employee.toLowerCase(), strings.Account)}
                </h2>
            </div>
            :
            <Table
                items={this.state.clientAccounts}
                allowClickRow
                handleClickRow={this.clickRow}
                unClickableCols={[0]}
                handleSelect={selectedClientAccounts => this.setState({ selectedClientAccounts })}
                uniqueIdentifier={"AccountId"}
                total={this.state.total}
                offset={this.state.offset}
                limit={this.state.limit}
                limitOptions={[20, 50, 100]}
                onPageClick={offset => this.setState({ offset }, () => this.getData())}
                onLimitChange={limit => this.setState({ offset: 0, limit }, () => this.getData())}
                readonly={true}
            >
                <TableHeader>
                    <TableRow>
                        {permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.EnterClientAccount) &&
                            <TableHeaderColumn style={{ width: 25, }} />
                        }
                        {this.state.clientColumns.IncludeName && 
                            <TableHeaderColumn>{strings.Name}</TableHeaderColumn>
                        }
                        {this.state.clientColumns.IncludeLastSeen && 
                            <TableHeaderColumn style={{ width: 150, }}>{strings.Last_Login}</TableHeaderColumn>
                        }
                        {this.state.clientColumns.IncludePEPM && 
                            <TableHeaderColumn style={{ width: 50, }}>{strings.PEPM}</TableHeaderColumn>
                        }
                        {this.state.clientColumns.IncludeSignUpDate && 
                            <TableHeaderColumn style={{ width: 150, }}>{strings.SignUp_Date}</TableHeaderColumn>
                        }
                        {this.state.clientColumns.IncludeDateUpdated && 
                            <TableHeaderColumn style={{ width: 150, }}>{strings.Date_Updated}</TableHeaderColumn>
                        }
                        {this.state.clientColumns.IncludeRelationshipManager && 
                            <TableHeaderColumn style={{ width: 150, }}>{strings.RelationshipManager}</TableHeaderColumn>
                        }
                        {this.state.clientColumns.IncludePlan && 
                            <TableHeaderColumn style={{ width: 100, }}>{strings.Plan}</TableHeaderColumn>
                        }
                        <TableHeaderColumn style={{ width: 15 }} />
                        <TableHeaderColumn style={{ ...styles.columnHeader, width: 50, float: Object.keys(this.state.clientColumns).filter(x => this.state.clientColumns[x] === true).length === 0 ? "right" : "none" }}>
                            <ColumnSelector
                                columns={[
                                    { label: strings.Name, show: true, value: this.state.clientColumns.IncludeName, propertyName: "IncludeName" },
                                    { label: strings.Last_Login, show: true, value: this.state.clientColumns.IncludeLastSeen, propertyName: "IncludeLastSeen" },
                                    { label: strings.PEPM, show: true, value: this.state.clientColumns.IncludePEPM, propertyName: "IncludePEPM" },
                                    { label: strings.SignUp_Date, show: true, value: this.state.clientColumns.IncludeSignUpDate, propertyName: "IncludeSignUpDate" },
                                    { label: strings.Date_Updated, show: true, value: this.state.clientColumns.IncludeDateUpdated, propertyName: "IncludeDateUpdated" },
                                    { label: strings.RelationshipManager, show: true, value: this.state.clientColumns.IncludeRelationshipManager, propertyName: "IncludeRelationshipManager" },
                                    { label: strings.Plan, show: true, value: this.state.clientColumns.IncludePlan, propertyName: "IncludePlan" },
                                ]}
                                handleChange={columns => {
                                    const clientColumns = {} as IAccountManagerClientsReportColumns
                                    columns.forEach(i => {
                                        clientColumns[i.propertyName] = i.value
                                    })
                                    this.setState({ clientColumns })
                                    localStorage.setItem("ClientColumns", JSON.stringify(clientColumns))
                                }}
                            />
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover deselectOnClickaway={false}>
                    {this.state.clientAccounts.map((row, i) =>
                        <TableRow key={row.AccountId} selected={this.state.selectedClientAccounts.find(item => item.AccountId === row.AccountId) ? true : false}>
                            {permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.EnterClientAccount) &&
                                <TableRowColumn data-intercom-target={i === 0 && "menu-Employees-openAccountInNewTab"} style={{ width: 25, }}>
                                    <ExternalLink
                                        url={`/?proxy=${row.AccountId}`}
                                    />
                                </TableRowColumn>
                            }
                            {this.state.clientColumns.IncludeName &&
                                <TableRowColumn>
                                    {row.Name}
                                </TableRowColumn>
                            }
                            {this.state.clientColumns.IncludeLastSeen &&
                                <TableRowColumn style={{ width: 150 }}>
                                    {row.LastSeenDateTimeLocal ? moment(row.LastSeenDateTimeLocal).format("HH:mm MM/DD/YYYY") : "NA"}
                                </TableRowColumn>
                            }
                            {this.state.clientColumns.IncludePEPM &&
                                <TableRowColumn style={{ width: 50 }}>
                                    ${row.BillingInfo && row.BillingInfo.PerEmployeePerMonthRate}
                                </TableRowColumn>
                            }
                            {this.state.clientColumns.IncludeSignUpDate &&
                                <TableRowColumn style={{ width: 150 }}>
                                    {row.ObjectAudit && moment(row.ObjectAudit.CreatedDate).format("HH:mm MM/DD/YYYY")}
                                </TableRowColumn>
                            }
                            {this.state.clientColumns.IncludeDateUpdated &&
                                <TableRowColumn style={{ width: 150 }}>
                                    {row.ObjectAudit && moment(row.ObjectAudit.LastModified).format("HH:mm MM/DD/YYYY")}
                                </TableRowColumn>
                            }
                            {this.state.clientColumns.IncludeRelationshipManager &&
                                <TableRowColumn style={{ width: 150 }}>
                                    {row.RelationShipManagerName}
                                </TableRowColumn>
                            }
                            {this.state.clientColumns.IncludePlan &&
                                <TableRowColumn style={{ width: 100 }}>
                                    {row.BillingInfo && EPlanType[row.BillingInfo.PlanType]}
                                </TableRowColumn>
                            }
                            <TableRowColumn style={{ width: 15 }}>
                                <FontIcon
                                    data-intercom-target={`accounts-Btn-OpenNotes_${i}`}
                                    className="fa fa-info-circle"
                                    style={{ fontSize: 16, color: "#777777", cursor: "pointer" }}
                                    onClick={permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.EditAccountManagerClientDetails) ? e => {
                                        e.stopPropagation()
                                        AppStateStore.setNoteDrawerContent({
                                            drawerTitle: `${strings.Account} "${row.Name}"`,
                                            objectData: {
                                                ObjectId: row.AccountId 
                                            },
                                            objectName: row.Name,
                                            dataType: "client",
                                        })
                                    } : null
                                    }
                                />
                            </TableRowColumn>
                            <TableRowColumn style={{ ...styles.columnValue, width: 50, float: Object.keys(this.state.clientColumns).filter(x => this.state.clientColumns[x] === true).length === 0 ? "right" : "none" }}></TableRowColumn>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
    )


    render() {
        return (
            <div className="AccountManagerTable" style={{ padding: 30 }}>
                {permissionHelper.hasAccountManagerPermission(AuthenticationStore.AccountManagerUserPermissions.Clients.CreateClientAccount) &&
                    <FloatingActionButton className="fixed-add" style={{ top: -25, right: 20, zIndex: 998 }} secondary={true} onTouchTap={() => this.clickRow(null)}>
                        <ContentAdd />
                    </FloatingActionButton>
                }
                <div style={{ display: "flex" }}>
                    <SelectField
                        floatingLabelText={strings.Active_Status}
                        value={this.state.activeClient}
                        onChange={(_e, _key, activeClient) => this.setState({ activeClient }, () => this.getData())}
                        style={{ marginLeft: 35, marginTop: -15, width: 250 }}
                    >
                        <MenuItem key={"active"} value={true} primaryText={strings.Active} />
                        <MenuItem key={"inactive"} value={false} primaryText={strings.Inactive} />
                    </SelectField>
                    <SelectField
                        floatingLabelText={strings.Account_Type}
                        value={this.state.accountType}
                        onChange={(_e, _key, accountType) => {
                            this.setState({ accountType }, () => this.getData())
                        }}
                        style={{ marginLeft: 35, marginTop: -15, width: 250 }}
                    >
                        <MenuItem key={"all"} value={strings.All} primaryText={strings.All} />
                        <MenuItem key={"test"} value={strings.Test_Account} primaryText={strings.Test_Account} />
                        <MenuItem key={"client"} value={strings.Client_Account} primaryText={strings.Client_Account} />
                        <MenuItem key={"demo"} value={strings.Demo_Account} primaryText={strings.Demo_Account} />
                    </SelectField>
                    <SelectField
                        floatingLabelText={strings.Plan}
                        value={this.state.planType}
                        onChange={(_e, _key, planType) => {
                            this.setState({ planType }, () => this.getData())
                        }}
                        style={{ marginLeft: 35, marginTop: -15, width: 250 }}
                    >
                        <MenuItem key={"all"} value={strings.All} primaryText={strings.All} />
                        {Object.keys(EPlanType).filter(key => !isNaN(Number(EPlanType[key]))).map((key, index) => (
                            <MenuItem key={index} value={key} primaryText={key} />
                        ))}
                    </SelectField>
                </div>
                <TableActionBar
                    rowSelectionCount={this.state.selectedClientAccounts.length}
                    singleSelectedMessage={strings.Client_Selected}
                    multipleSelectedMessage={strings.x_Client_Selected}
                    title={`${strings.Client} ${strings.Account}s`}
                    onSearch={searchText => this.onSearchChange(searchText)}
                    reloadTable={this.getData}
                    exportTable={this.getDataDownload}
                    searchText={this.state.searchText}
                    searchTextFieldWidth={"92%"}
                    readonly={true}
                />

                {this.state.loading ?
                    <div className="spinner">
                        <CircularProgress />
                    </div> :
                    this.AccountsTable()
                }

                <AccountManagerClientTabDrawer
                    accountId={this.state.selectedAccountId}
                    editDrawer={this.state.editDrawer}
                    drawerOpen={this.state.drawerOpen}
                    closeDrawer={() => this.setState({ drawerOpen: false, editDrawer: false, selectedAccountId: null })}
                    reloadData={this.getData}
                />
            </div>
        )
    }
}

const styles = {
	columnValue: {
		textAlign: "left",
		paddingLeft: 5,
		paddingRight: 5
	},
	columnHeader: {
		textAlign: "left",
		paddingLeft: 5,
		paddingRight: 5
	}
}